import { render, staticRenderFns } from "./AdminEventsCard.vue?vue&type=template&id=2440a29c"
import script from "./AdminEventsCard.vue?vue&type=script&lang=js"
export * from "./AdminEventsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports